import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

function ServiceDesOne() {
  return (
    <Container className="p-3" >
      <Row style={{ justifyContent: 'center' }} >
        <Row className='mt-3'>
          <Col className='service_des_title' > Upper GI Tract Problems </Col>
        </Row>
        <Row className='mt-3'>
          <Col>
            <p className='service_des_p' >
              GI tract is a common way of referring to the digestive system. It starts with the mouth and ends with the anus. The GI tract starts at mouth, where you chew your food and swallow it down into your throat, then it goes through your esophagus, stomach and into the small intestine. From there, it then crosses over from the small intestine to the large intestine which terminates at rectum before exiting out of the anus.
            </p>
            <p>
              The upper part of our GI tract is from our throat to top of our esophagus. This part is mainly responsible for helping digest food and liquid that we have eaten or drunk. There are many muscles in this area that help push food down into our stomach using peristaltic waves (a wave-like motion) that occur in our esophagus when we swallow food or drink liquids. The upper GI tract needs hydrochloric acid in order to function properly since this is where most digestion takes place meaning anything occurring before you reach.
            </p>
          </Col>
        </Row>
        <Row className='mt-3'>
          <Col className='service_des_title'>Upper GI Tract Procedures </Col>
        </Row>
        <Row className='mt-3'>
          <Col className='service_des_p' >
            <p> The upper GI series is one of several specific GI X-ray exams that use fluoroscopy to examine different sets of organs along your gastrointestinal tract. </p>
            <ul>
              <li>An esophagram (also called a barium swallow test) examines your esophagus specifically.</li>
              <li> The upper GI series examines your esophagus, stomach and upper small intestine (duodenum).</li>
              <li> The small bowel series (also called small bowel follow-through) examines your small intestine specifically.</li>
              <li> The lower bowel series (also called barium enema) examines your lower small intestine (ileum) and your large intestine.</li>
            </ul>
            <p> Your esophagus, stomach and duodenum are grouped together as your “upper GI tract” for a few reasons:</p>
            <ul>
              <li>This is about as far into the GI tract as a medical instrument can reach from the top down.</li>
              <li>A substance that you ingest will pass through all of these parts relatively quickly, compared with the long, coiled bowels, which require separate exams.</li>
              <li>Diseases that affect one of these parts can often affect the others. So, even if you only have symptoms in one part, it can be helpful to look at them as a group.</li>
            </ul>
          </Col>
        </Row>
      </Row>
    </Container>
  )
}

export default ServiceDesOne